import { render, staticRenderFns } from "./SpeakingTurns.vue?vue&type=template&id=69749eae&scoped=true"
import script from "./SpeakingTurns.vue?vue&type=script&lang=js"
export * from "./SpeakingTurns.vue?vue&type=script&lang=js"
import style0 from "./SpeakingTurns.vue?vue&type=style&index=0&id=69749eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69749eae",
  null
  
)

/* custom blocks */
import block0 from "./SpeakingTurns.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports